import { IRelocationLimit } from '@/api';

export class DeleteRelocationLimit
    implements IRelocationLimit {

    public readonly id: string;
    public readonly IsDeleted: boolean = true;

    constructor(id: string) {
        if (!id || typeof(id) !== 'string' || id.length <= 0) {
            throw new Error(`Invalid relocation limit identifier value '${id}'`);
        }

        this.id = id;
    }
}
